<template>
    <div class="text-center">
        <div id="element">
            <mu-row class="px-5">
                <mu-col class="col-services p-1" :span="12" :sm="12" :md="6" :lg="size" :xl="size"
                    v-for="(img, index) of images" :key="`service_${index}`" @mouseover="section_hover = img.id">
                    <picture v-scroll-reveal>
                        <source :srcset="`${img.src}.webp`" :alt="img.alt" width="100%" type="image/webp" />
                        <img :src="`${img.src}.jpg`" :alt="img.alt" width="100%" />
                    </picture>
                    <mu-col class="home-services-text"
                        :class="(show_message) ? { 'visible': section_hover === img.id } : { 'hover': section_hover === img.id }">
                        <a :href="`${img.url}`" class="link" v-show="!show_message && img.url != undefined"></a>
                        <table style="width: 100%; height: 100%;" v-show="show_message">
                            <tbody>
                                <tr>
                                    <td class="text-center align-middle">
                                        <span v-html="img.message"></span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </mu-col>
                </mu-col>
            </mu-row>
        </div>
    </div>
</template>
<script>

export default {
    // name: 'services',
    props: {
        images: {
            type: Array,
            required: true
        },
        size: {
            type: Number,
            required: true
        },
        time: {
            type: Number,
            required: false,
            default: 0
        },
        show_message: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data() {
        return {
            section_hover: ""
        }
    }
}
</script>

<style lang="scss">
.col-services {
    padding: 0px 0px;
}

.col-services .home-services {
    position: relative;
}

.col-services .home-services-title {
    position: absolute;

    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    padding: 40px 40px;

    font-size: 25px;
    text-align: center;
    color: white;

    z-index: 5;

    // a {
    //     text-decoration: none;
    //     color: white;
    // }
}

.col-services .home-services-text {

    transition: all .25s ease-in-out;
    transition-property: all;
    transition-duration: 0.25s;
    transition-timing-function: ease-in-out;
    transition-delay: 0s;

    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    padding: 40px 30px;

    font-size: 16px;
    text-align: center;
    color: white;

    background-color: #000;
    z-index: 10;

    opacity: 0;
}

.col-services .home-services-text.visible {
    opacity: 1;
}


.img-hooper {
    width: 100%;
    height: auto;
}

.link {
    padding: 12px 128px 147px 153px;
}
</style>